import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { TIME_FORMAT } from 'utils/constants/formats';

const TimeDisplay = ({
  className,
  time_from,
  time_to,
  time_from_tz,
  time_to_tz
}) => {
  const getHours = (date, timeZone) =>
    moment(date, moment.ISO_8601)
      .tz(timeZone)
      .format(TIME_FORMAT);

  return (
    <div className={className} data-testid="time-display">
      <div className="time-display">
        {`${getHours(time_from, time_from_tz)} - ${getHours(
          time_to,
          time_to_tz
        )}`}
      </div>
    </div>
  );
};

TimeDisplay.propTypes = {
  className: PropTypes.string.isRequired,
  time_from: PropTypes.string.isRequired,
  time_to: PropTypes.string.isRequired,
  time_from_tz: PropTypes.string.isRequired,
  time_to_tz: PropTypes.string.isRequired
};
export default TimeDisplay;
